<template>
  <div class="plugin-wrapper" v-if="list">
    <template v-if="!isMaster">
      <div class="m-search-results-products__img">
        <picture>
          <source media="(min-width: 1366px)" srcset="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-top-large.png, @/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-top-large@2x.png 2x">
          <source media="(min-width: 1024px)" srcset="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-top-large.png, @/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-top-large@2x.png 2x">
          <source media="(min-width: 768px)" srcset="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-top-large.png, @/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-top-large@2x.png 2x">
          <source media="(min-width: 0px)" srcset="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-top.png, @/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-top@2x.png 2x">
          <img class=" lazyloaded" alt="Sisley Paris" srcset="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-top-large@2x.png 2x" src="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-top-large.png">
        </picture>
      </div>
      <div class="m-search-results-products__img">
        <picture>
          <source media="(min-width: 1366px)"  srcset="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-bottom-large.png, @/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-bottom-large@2x.png 2x">
          <source media="(min-width: 1024px)" srcset="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-bottom-large.png, @/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-bottom-large@2x.png 2x">
          <source media="(min-width: 768px)" srcset="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-bottom-large.png, @/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-bottom-large@2x.png 2x">
          <source media="(min-width: 0px)" srcset="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-bottom.png, @/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-bottom@2x.png 2x">
          <img class=" lazyloaded" alt="Sisley Paris" srcset="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-bottom-large@2x.png 2x" src="@/assets/imgs/bg/category/hair-rituel/hr-product-grid-bg-bottom-large.png">
        </picture>
      </div>
    </template>
    <div class="plugin-category_list layout">
      <div class="sort_box" v-if="sort">
        <SelectSort :options="sortKewards" labelField="name" valueField="id" :value="chooseSort.name" @select="onSelectCountry" />
      </div>
      <div class="sort_box_little" @click="toggleSortFlag" v-if="sort">
        <div class="plp_sort">
          <div>{{chooseSort.name}}</div>
          <i class="iconfont" style="transform: rotate(90deg);">&#xe636;</i>
        </div>
      </div>
      <div class="ms-row">
        <template v-for="(item, index) in list">
          <template v-if="item.show_type == 1 && item.colspan == 2">
            <div class="col-xs-12 col-md-8" :key="index">
              <BaseItem :source="item" :enableFavorite="true" />
            </div>
          </template>
          <template v-else-if="item.show_type == 2">
            <div class="col-xs-12 col-md-8" :key="index">
              <PushItem :source="item" :height="rowImgH" />
            </div>
          </template>
          <template v-else>
            <div class="col-xs-6 col-md-4" :key="index">
              <BaseItem :source="item" :enableFavorite="true" />
            </div>
          </template>
        </template>
      </div>
    </div>
    <!-- 单品的SKU选择框 -->
    <div class="modal" v-if="sortFlag">
      <div class="select-list">
        <div class="select-title">排序</div>
        <div class="c-button c-button--rounded close-icon" @click="toggleSortFlag()">
          <i class="iconfont">&#xe615;</i>
        </div>
        <div class="item-skus__list">
            <ul>
              <li
                class="color-li"
                v-for="(item, index) in sortKewards" :key="index"
                @click="onSelectCountryMobile(item)"
              >
                <div class>
                  <span>{{ item.name }}</span>
                </div>
                <i class="iconfont">{{ chooseSortMobile.id == item.id ? '&#xe640;' : '&#xe60f;' }}</i>
              </li>
            </ul>
        </div>
        <button class="c-button c-button--primary btn_sort" @click="setFakeSKUIndex()">确定</button>
      </div>
    </div>
    <div class="list-btm__spliter"></div>
    <ListLoading :visible="ajaxing" />
  </div>
</template>

<script>
import BaseItem from '@/components/BaseItem';
import PushItem from '@/components/PushItem';
import ListLoading from '@/components/ListLoading';
import api from '@/utils/api';
import types from '@/store/types';
import utils from '@/utils';
import SelectSort from '@/components/SelectSort'

export default {
  name: "CategoryList",
  components: { BaseItem, PushItem, ListLoading, SelectSort },
  props: {
    config: {
      type: Object,
      required: true
    },
    info: { type: Object, required: false },
    sort: {
      type: Boolean,
      value: false
    }
  },
  data() {
    return {
      hasNext: true,
      ajaxing: false,
      from: (utils.isMobile() || utils.isWXBrowser()) ? 2 : 3, // 来源 1:小程序 2:mobile  3:pc
      row_product_num: 3,
      need_ad: 1,
      page: 0,
      list: [],
      evtInited: false,
      rowImgH: '0px',
      sortKewards:[{
        name:'人气推荐',
        id:'0'
      },{
        name:'新品上市',
        id:'1'
      },{
        name:'价格由高到低',
        id:'2'
      },{
        name:'价格由低到高',
        id:'3'
      }],
      chooseSort:{
        name:'人气推荐',
        id:'0'
      },
      chooseSortMobile:{
        name:'人气推荐',
        id:'0'
      },
      sortFlag: false
    };
  },
  created() {
    // 函数防抖处理
    this.doResize = utils.throttle(this.doResize, 200);
    this.initPramas();
    this.loadSource();
  },
  methods: {
    initPramas() {
      let winW = window.innerWidth;
      this.row_product_num = winW >= 1024 ? 3 : 2;
    },
    getPageSize(items, pageSize = 10) {
      if (Array.isArray(items) && items.length) {
        if (items.length == pageSize) return items.length;
        return items.reduce((outerPrevious, outerCurrent) => {
          return outerPrevious + (outerCurrent.show_type || 1);
        }, 0);
      }
    },
    loadSource() {
      if (this.ajaxing) return false;
      this.ajaxing = true;
      let { page, from, row_product_num } = this;
      api[types.$CMP_CATEGORY_LIST]({ cat_id: this.config.category_id, page: page + 1, from, row_product_num, simple: 1, sort: this.chooseSort.id || '0' }).then(res => {
        if (res.code == 1) {
          let { pageData, curPage, totalPage } = res.data;
          if (page == 0) {
            this.list = pageData;
          } else {
            this.list = this.list.concat(pageData);
          }
          // 
          // let size = this.getPageSize(items);
          this.hasNext = curPage < totalPage;
          // 加载成功结束后才修改当前页，以免加载失败的处理
          this.page += 1;
        } else {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
        if (!this.evtInited) {
          this.$nextTick(() => {
            this.initEvent();
          });
        }
        this.ajaxing = false;
        // 
        this.gtmTrackCategory();
      }).catch(err => {
        this.ajaxing = false;
        console.warn(err);
      });
    },
    // 加载下一页
    loadNextPage() {
      this.hasNext && this.loadSource();
    },
    initEvent() {
      this.evtInited = true;
      this.resizeObserverTarget = document.querySelectorAll(".plugin-category_list .col-md-4 .tile__image-container");
      // this.resizeObserverTarget = document.querySelectorAll(".plugin-category_list .col-md-4:nth-child(-n+3) .tile__image-container img");
      // 
      setTimeout(() => {
        this.doResize();
      }, 500);
      // Resize 事件处理
      window.addEventListener('resize', this.doResize, false);
      // 
      // npm install resize-observer-polyfill --save-dev
      // const observer = new ResizeObserver(entries => {
      //   this.rowImgH = entries[0].contentRect.height + 'px';
      // });
      // observer.observe(this.resizeObserverTarget);
      // 检测观察目标是否出现
      let target = document.querySelector(".list-btm__spliter");
      if (window.IntersectionObserver) {
        this.io = new IntersectionObserver(entries => {
          let ratio = entries[0].intersectionRatio;
          if (ratio > 0) {
            this.loadNextPage();
          }
        }, {
          root: null,
          rootMargin: "0px",
          threshold: [1]
        });
        this.io.observe(target);
      }
      // 
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("resize", this.doResize, false);
        if (this.io?.disconnect) {
          this.io.disconnect();
          this.io = null;
        }
      });
    },
    doResize() {
      if (!this.resizeObserverTarget) {
        this.resizeObserverTarget = document.querySelectorAll(".plugin-category_list .col-md-4 .tile__image-container");
      }
      if (this.resizeObserverTarget) {
        this.rowImgH = Math.max(...Array.from(this.resizeObserverTarget).map(domItem => {
          return parseFloat(window.getComputedStyle(domItem, null).height);
        })) + 'px';
      }
    },
    getItemSKUID(item) {
      let targetId = -1; // SKU_ID or Unique_ID+SKU1_ID+SKU2_ID+...
      // 组合礼盒
      if (item.display_type == "collection") {
        targetId = `{{${item.unique_id}}}${item.products.reduce((pre,cur)=>{
          return pre + `{{${cur.skus?.[0]?.sku_id}}}`
        }, '')}`;
      } else if (item.display_type == "collection_sku") {
        targetId = item.skus?.[0]?.sku_id;
      } else if (["capacity_ml", "capacity_g", "color"].indexOf(item.display_type) != -1) {
        targetId = item.skus?.[0]?.sku_id;
      } else {
        targetId = item.skus?.[0]?.sku_id;
      }
      return targetId;
    },
    // GTM
    gtmTrackCategory() {
      if (!window.dataLayer) return false;
      window.dataLayer.push({
        ecommerce: {
          currencyCode: 'CNY',
          impressions: this.list.map((item, index) => {
            return {
              id: this.getItemSKUID(item),
              name: item.product_name,
              price: item.default_price || item.lowest_price || '',
              productType: ['collection', 'collection_sku'].indexOf(item.display_type) != -1 ? 'bundle' : item?.skus?.length > 1 ? 'configured' : 'simple',
              list: this?.info?.cat_name || 'Product_List',
              position: index
            }
          })
        }
      });
    },
    onSelectCountry(item) {
      this.chooseSort = item
      this.page = 0
      this.list = []
      this.loadSource()
    },
    onSelectCountryMobile(item) {
      this.chooseSortMobile = item
    },
    toggleSortFlag() {
      if(!this.sortFlag) this.chooseSortMobile = this.chooseSort
      this.sortFlag = !this.sortFlag
    },
    setFakeSKUIndex() {
      this.chooseSort = this.chooseSortMobile
      this.toggleSortFlag()
      this.page = 0
      this.list = []
      this.loadSource()
    }
  },
  computed: {
    isMaster() {
      return this.$store.state.isMaster;
    }
  },
  watch: {
    'config.category_id'() {
      this.page = 0;
      this.loadSource();
    }
  }
}
</script>

<style lang="scss" scoped>
  .plugin-category_list {
    padding: 0 17px;
    & /deep/ .plugin-wrapper {
      margin: 1.5625rem 0;
    }
    .col-md-8 /deep/ .item-tile { max-width: 100%; }
  }
  .list-btm__spliter { height: 10px; }
  // 
  .plugin-wrapper {
    position: relative;
    .m-search-results-products__img {
      position: absolute;
      &:first-child { top: 0; left: 0; }
      &:nth-child(2) {
        position: absolute; top: 50%; right: 0; transform: translateY(-50%) translateY(-.5px); 
      }
    }
  }
  .sort_box{
    display: none;
  }
  .sort_box_little{
    display: block;
    cursor: pointer;
    .plp_sort{
      height: 38px;
      width: 100%;
      display: flex;
      justify-content: center;
      border: 1px solid #ccc;
      border-radius: 3.75rem;
      align-items: center;
      .plp_arow {
          // @include iconfont('\e661');
          font-size: 0.6875rem;
          color: #363F4D;
          margin-left: 1.875rem;
      }
    }
  }
  .modal { position: fixed; top: 0; left: 0; min-width: 100%; height: 100%; z-index: 99; background-color: rgba(0, 0, 0, 0.5); display: block;}
   .select-list {
    position: absolute;
    bottom: 0;
    z-index: 1;
    background: #fff;
    box-shadow: 0 0 0.625rem 0 #ccc;
    margin-top: 0.3125rem;
    padding: 1.875rem;
    min-width: 10.6875rem;
    width: 100%;
    overflow: auto;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    .select-li, .capacity-li, .color-li { cursor: pointer; }
    button.hide-for-sm { display: block; width: 100%; }
    &.color__list {
      padding: 1.875rem 1.25rem 1.875rem 1.875rem;
      .item-skus__list ul { padding-right: 0.625rem; }
    }
    .btn_sort{
      width: 100%;
    }
  }
  .select-li {
    display: block; padding: 0.625rem; border-radius: 0.5rem; cursor: pointer;
    &.selected { background-color: #f5f5f5; }
  }
  .select-title { display: block; font-size: 1.125rem;margin-bottom: 20px; }
  .color-li {
    padding: 0.625rem 0; display: flex; justify-content: space-between; align-items: center;
    &:first-child { padding-top: 0; }
    &:last-child { padding-bottom: 0; }
    .iconfont { color: #000; }
  }
  .capacity-li {
    display: flex; justify-content: space-between; align-items: center; padding: 0.625rem 0; border-bottom: 1px solid #dcdcdc;
    .iconfont { color: #000; }
  }
  .close-icon { width: 1.5rem; height: 1.5rem; line-height: 1.4rem; text-align: center; display: block; position: absolute; right: 1.25rem; top: 1.25rem; }
  @media screen and (min-width: 48em) {
    .plugin-category_list {
      & /deep/ .plugin-wrapper {
        margin: 2.5rem 0;
      }
    }
  }
  @media screen and (min-width: 64em) {
    .plugin-category_list {
      & /deep/ .plugin-wrapper {
        margin: 1.25rem 0;
      }
      .col-md-8 /deep/ .item-tile { max-width: 49.875rem; }
    }
    .sort_box{
      display: block;
    }
    .sort_box_little{
      display: none;
    }
    .modal{
      display: none;
    }
  }
  @media screen and (min-width: 75em) {
    .plugin-category_list {
      padding: 0;
      & /deep/ .plugin-wrapper {
        margin: 3.125rem 0;
      }
    }
  }
</style>